module.exports = __webpack_public_path__ + "static/media/dbtsdigital_logo.63949bbe.svg";